import { load } from './component-loader'

const Lookup = load('returns/Lookup')
const GiftLookup = load('returns/GiftLookup')
const SelectItems = load('returns/SelectItems')
const RefundMethod = load('returns/RefundMethod')
const ReturnMethod = load('returns/ReturnMethod')
const ReturnConfirmation = load('returns/ReturnConfirmation')

const initialTitle = " | Eichlers  ";
export default [
    {
        path:'/return',
        name:'ReturnLookup',
        component:Lookup,
        meta:{title:'Start a return' + initialTitle},
        props:true
    },
    {
        path:'/gift-return',
        name:'GiftReturnLookup',
        component:GiftLookup,
        meta:{title:'Gift return' + initialTitle},
        props:true
    },
    {
        path:'/select-items-to-return',
        name:'ReturnSelectItems',
        component:SelectItems,
        meta:{title:'Select Items To Return' + initialTitle},
        props:true 
    },
    {
        path:'/choose-a-refund-method',
        name:'RefundMethod',
        component:RefundMethod,
        meta:{title:'Choose a refund method' + initialTitle},
        props:true 
    },
    {
        path:'/choose-a-return-method',
        name:'ReturnMethod',
        component:ReturnMethod,
        meta:{title:'Choose a return method' + initialTitle},
        props:true 
    },
    {
        path:'/return-confirmation/:return_id',
        name:'ReturnConfirmation',
        component:ReturnConfirmation,
        meta:{title:'Return confirmation' + initialTitle}
    }
]


// WEBPACK FOOTER //
// ./resources/js/router/returns.js